import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';
import HookFormTextField from 'src/components/hookform/HookFormTextField';
import BackButton from 'src/components/BackButton';
import SuccessButton from 'src/components/SuccessButton';

const schema = Yup.object().shape({
  name: Yup.string().trim().required('Ring name is required'),
  deferralDays: Yup.number()
    .typeError('Deferral days must be a number')
    .integer('Deferral days must be a whole number')
    .min(0, 'Deferral days must be 0 or greater')
    .required('Deferral days is required'),
});

const DEFAULT_VALUES = {
  name: '',
  deferralDays: 0,
};

const AddDeploymentRingForm = ({ loading, onCancel, onSubmit }) => {
  const formMethods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: DEFAULT_VALUES,
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;

  const submit = values =>
    onSubmit({
      name: values.name.trim(),
      deferralDays: Number(values.deferralDays),
    });

  return (
    <form autoComplete="off" onSubmit={handleSubmit(submit)}>
      <Stack spacing={2} pt={1}>
        <HookFormTextField
          name="name"
          label="Ring name"
          formMethods={formMethods}
          size="small"
          fullWidth
        />
        <HookFormTextField
          name="deferralDays"
          label="Deferral days"
          formMethods={formMethods}
          type="number"
          helperText="Days the policy waits to be deployed to this ring after it is configured for deployment."
          size="small"
          fullWidth
        />
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <BackButton disabled={loading} onClick={onCancel}>
            Cancel
          </BackButton>
          <SuccessButton type="submit" disabled={loading || !isValid} loading={loading}>
            Add Ring
          </SuccessButton>
        </Stack>
      </Stack>
    </form>
  );
};

AddDeploymentRingForm.propTypes = {
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddDeploymentRingForm;
